<template>
    <Dialog v-model:visible="noExiste" modal header="AVISO" closable="false" v-on:hide="goHome"  :style="{ width: '35vw' }">
      <div>
        <Avatar icon="pi pi-thumbs-down-fill" class="mr-2 ml-5 text-orange-700" size="xlarge" shape="circle" />
        <span class="text-700 font-semibold fadein mr-4"> No existe este expediente</span>
      </div>
      <template #footer>
            <Button label="Ok" icon="pi pi-check" @click="goHome" autofocus />
      </template>
    </Dialog>
    <Dialog v-model:visible="enProceso" modal header="AVISO" closable="false" v-on:hide="goHome"  :style="{ width: '35vw' }">
      <div class="grid" >
        <div class="col-3">
          <Avatar icon="pi pi-times-circle" class="mr-2 ml-5 avisoWarning" size="xlarge"  />
        </div>
        <div class="col-9">
          <span class="text-700 font-semibold fadein mr-4">{{mensajeWarning}}</span>
        </div>
      </div>
      <template #footer>
            <Button label="Ok" icon="pi pi-check" @click="goHome" autofocus />
      </template>
    </Dialog>

    <div class="containter m-5 grid">
      <Card  class=" col-12   surface-50">
        <template #title>
            <span class="text-base  md:text-2xl text-700">Expediente: <strong class="text-800">{{ originalExp }}</strong></span>        
        </template>
        <template #content>
          <div class="grid">
            <div class="col-12 md:col-6 lg:col-6">
              <div class="field" v-if="false">
                  <label for="nombre">Nombre</label>
                  <input readonly id="firstname1" v-model="dataset.nombre" type="text" class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
              </div>
              <div class="field">
                  <label for="firstname1">Ubicacion Predio</label>
                  <input readonly id="nombre" v-model="dataset.ubicacionPredio" type="text" class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-6">
              <div class="field" v-if="false">
                  <label for="direccion">Dirección</label>
                  <input readonly id="direccion" v-model="dataset.direccion" type="text" class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
              </div>
              <div class="field">
                  <label for="colonia">Colonia</label>
                  <input readonly id="colonia" v-model="dataset.colonia" type="text" class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
              </div>
            </div>
            <div class="p-float-label col-12 md:col-6 lg:col-3">
              <InputNumber readonly inputId="construccion" v-model="dataset.construccion" mode="decimal"   :minFractionDigits="2" />
              <label for="construccion">Contrucción</label>
            </div>
              
            <div class="p-float-label col-12 md:col-6 lg:col-3">
              <InputNumber readonly inputId="terreno" v-model="dataset.terreno" mode="decimal"   :minFractionDigits="2" />
              <label for="terreno">Terreno</label>
            </div>
            <div class="p-float-label col-12 md:col-6 lg:col-3">
              <InputNumber readonly inputId="valorCatrastral" v-model="dataset.valorCatrastral"  mode="currency" currency="USD" locale="en-US" />
              <label for="valorCatrastral">Valor catastral</label>
            </div>
            <div class="p-float-label col-12 md:col-6 lg:col-3">
              <InputText readonly inputId="claveAnualBimestral" v-model="dataset.claveAnualBimestrak"     />
              <label for="claveAnualBimestral">Clave Bimestral</label>
            </div>

          </div>
          <div class="grid mt-2">
           <div class="col-10 mx-auto"> 
             <DataTable v-if="totales > 0" :value="dataset.conceptos" stripedRows tableClass="edoCuenta"  >
               <Column field="anio" header="AÑO"></Column>
               <Column field="bimestre" header="BIMESTRE"></Column>
                <!-- <Column field="conceptoClave" header="CLAVE CONCEPTO"></Column>
               <Column field="tipoConcepto" header="TIPO CONCEPTO"></Column>   -->
               <Column field="conceptoDescripcion" header="CONCEPTO"></Column>
               <Column field="importe" header="TOTAL PENDIENTE" class="align-content-end">
                   <template #body="slotProps" >
                       <div class="flex justify-content-end " :class="{' text-red-500':getImporteClass(slotProps.data.tipoConcepto)} ">    {{getImporte(slotProps.data.importe,slotProps.data.tipoConcepto )}} </div>
                   </template>
               </Column>
               <template #footer> 
                  <div class="grid">
                    <div class="col-6 md:col-9 text-lg md:text-xl ">
                      Total a pagar:
                    </div>
                    <div class="col-6 md:col-3 text-lg md:text-xl ">
                     {{formatCurrency( totales)}} 
                    </div>
                  </div>
              </template>
             </DataTable>
             <Card v-else    class="col-6 mx-auto">
              <template #content>
                 <span > <i class="pi pi-thumbs-up text-5xl font-bold text-green-500" ></i> <span class="underline ml-4 text-green-700 text-xl font-bold"> El Expediente no tiene adeudos pendientes  </span></span>
              </template>
             </Card>
           </div> 
          </div>

        </template>
        <template #footer>
          <div class="flex justify-content-around flex-wrap w-full ">
            <div class="flex align-items-center justify-content-center col-12 md:col-4">
              <Button icon="pi pi-backward" label="Empezar" class="p-button-info " @click="goHome" />
            </div>
            <div v-if="!noExiste" class="flex align-items-center justify-content-center col-12 md:col-4">
              <Button icon="pi pi-check" label="Confirmar"  class="p-button-warning " @click="pagaBanco" :disabled="totales == 0" />
            </div>
          </div>
        </template>
    </Card>
    <form ref="form" method="post" >
        <input type="hidden" name="field1" ref="field1">
        <input type="hidden" name="field2" ref="field2" value="">
        <input type="hidden" name="field3" ref="field3" >

    </form>
  </div>
 </template>
 
<script>
 import { ref,computed  } from '@vue/reactivity';
 import { useToast } from "primevue/usetoast";
 import predialAPI from "@/composables/PredialAPI";
 import edoCuentaStore from "@/composables/edoCuentaStore";
export default {
    setup(props,{ emit }) {
      const toast = useToast();
      const { getExpediente,redirectBanco } = predialAPI();
      const {setEdoCuenta,clearEdoCuenta} = edoCuentaStore();
      var expediente=""
      let mensajeWarning = "";
      var originalExp= ref("")
      const dataset =  ref([]);
      var totales=0.1;
      let noExiste = ref(false)
      let enProceso = ref(false)
   // expose to template and other options API hooks
    return {
      emit,dataset, expediente,originalExp,getExpediente,redirectBanco,totales,noExiste,toast,
      setEdoCuenta,clearEdoCuenta,enProceso,mensajeWarning
    }
 },
  methods: {
    getImporteClass( tipoConcepto) {
      let isRed=false
      if (tipoConcepto == "A") {
        isRed = true
      }
      return isRed;
    },
    getImporte(importe, concepto) {
      if (concepto == "A") {
        importe = importe * -1;
      }
      return this.formatCurrency(importe)
    },
    formatNumeric(number) {
        return  new Intl.NumberFormat().format(number)
    },
    formatCurrency(number) {
        const tipoMoneda = { style: 'currency', currency: 'USD' };
        return new Intl.NumberFormat('en-US', tipoMoneda).format(number);
    },
    obtenTotales() {
      const sumatoria= (acum, val) => {
          if (val.conceptoClave == 5) 
            return acum - val.importe
          else
            return acum + val.importe
      }
      return this.dataset.conceptos.reduce(sumatoria, 0);
     // return 999239.9332
    },
    pagaBanco() {
     this.emit("currentStep",3)
     this.$refs.field1.value="Me la pelas!";
     this.$refs.field2.value="Claro que sí";
     this.$refs.field3.value="Me la super pelas!";
     this.$refs.form.action=process.env.VUE_APP_URL_MULTIPAGOS  

  //  this.$refs.form.submit()

    },
    goHome() {
      this.emit("currentStep",1)
    },
    async cargaExpediente() {
      const ds =  await this.getExpediente(this.expediente)
      this.dataset = ds;
      if (Object.keys(ds).length === 0) {
        this.noExiste = true;
        return;
      }
      this.noExiste = false
      
      if (this.dataset.hasOwnProperty("WARNING")) {
        this.mensajeWarning=this.dataset.WARNING
        this.enProceso = true;
        return;
      }
      this.enProceso = false;

      this.totales = this.obtenTotales();
      const estadoCuenta = {
        id:          this.dataset.id,       
        expediente:  this.dataset.expediente, 
        numCarga:    this.dataset.numCarga,
        fCarga:      this.dataset.fCarga 
      }
      this.setEdoCuenta(estadoCuenta);
    }
 },
 
 mounted() {
   this.expediente = this.$route.params.expediente.replaceAll("-","");
   this.originalExp  = this.$route.params.expediente
   this.cargaExpediente()
 }
}
</script>
<style lang="scss">
 $HeadBackgroud: rgb(219, 223, 225);

 
 .edoCuenta {
 
  thead th:nth-child(1) {
    width: 5%;
    background-color: $HeadBackgroud;
  }
  thead th:nth-child(2) {
    width: 5%;
    text-align: center;
  }
  thead th:nth-child(3) {
    width: 5%;
  }
  thead th:nth-child(4) {
    width: 5%;
  }
  tbody tr {
      transition: background-color 150ms ease-out;
      text-align: center;
      height: 20px;
      &:hover {
        background-color: rgb(231, 235, 236);
      }
  }
  tbody td:nth-child(1) {
      text-align: center;
  }
  
  thead th   {
  //  font-family: "Rock Salt", cursive;
    text-align: center  !important;
    background-color:  $HeadBackgroud !important;
  }

  tfoot th {
    background-color: blueviolet;

  }
  tfoot th:nth-child(1) {
    width: 55%;
    background-color: $HeadBackgroud;
    column-span: 4;
  }

}

.footerLabel {
  background-color: $HeadBackgroud;
  font-weight: 700;
  font-size: larger;
}
.footerData {
  font-weight: 400;
}

.avisoWarning {
  background-color:orangered;
  color: white;
}

 </style>